import React from 'react';
import TrackerInputShell from './TrackerInputShell';

interface BinaryButtonProps {
  active?: boolean;
  last?: boolean;
  onClick(): void;
}

interface BinaryInputProps {
  name: string;
  value?: BinaryValue;
  callback(value: BinaryValue): void;
}

const BinaryButton: React.FC<BinaryButtonProps> = ({ children, active, last = false, onClick }) => (
  <button
    type="button"
    className={`f6 sans-serif round-input ${last ? 'mr0' : 'mr1'} ${
      active ? 'bg-navy white' : 'ba b--light-gray navy'
    } `}
    onClick={onClick}
  >
    {children}
  </button>
);

const BinaryInput: React.FC<BinaryInputProps> = ({ name, value = null, callback }) => (
  <TrackerInputShell trackerName={name}>
    <BinaryButton active={value === 1} onClick={() => callback(1)}>
      y
    </BinaryButton>
    <BinaryButton active={value === 0} onClick={() => callback(0)} last={true}>
      n
    </BinaryButton>
  </TrackerInputShell>
);

export default BinaryInput;
